var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666656 14.8334C0.666656 16.25 1.74999 17.3334 3.16666 17.3334H14.8333C16.25 17.3334 17.3333 16.25 17.3333 14.8334V8.16669H0.666656V14.8334ZM14.8333 2.33335H13.1667V1.50002C13.1667 1.00002 12.8333 0.666687 12.3333 0.666687C11.8333 0.666687 11.5 1.00002 11.5 1.50002V2.33335H6.49999V1.50002C6.49999 1.00002 6.16666 0.666687 5.66666 0.666687C5.16666 0.666687 4.83332 1.00002 4.83332 1.50002V2.33335H3.16666C1.74999 2.33335 0.666656 3.41669 0.666656 4.83335V6.50002H17.3333V4.83335C17.3333 3.41669 16.25 2.33335 14.8333 2.33335Z",
    fill: "#536425"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.9b8715f993d3f97b617e74ed30b98324.svg";
export { ForwardRef as ReactComponent };